import React from 'react';
import Navigation from '../../components/navigation'
import {Link} from 'react-router-dom'
import playOS from './../../images/play_circle_orange_s.png'
import './index.css'
export default class index extends React.Component {
    state = {
        num:0,
        numList:[]
    }
    componentWillMount(){
        var arr_4=new Array()
        function getRandom() {                                             //随机数
            var random = Math.random()*7;                                            //向下取整
            random = Math.floor(random);
            if(arr_4.length < 4)                         //判断数组长度
            {   
                for(var i=0;i<=arr_4.length;i++)             //遍历数组。
                {
                    if(random==arr_4[i])                    //比较随机数
                    {   
                        break;
                    }
                    else                               
                    {
                        if(i==arr_4.length)
                        {arr_4.push(random);break;}
                    }
                };
                getRandom(0,10);
            }
             
        }
        getRandom(0,6);
        this.setState({numList:arr_4})
    }
    render(){
        return (
            <main>
                <Navigation tab="match"></Navigation>
                <div className="detail_title"> <Link to="/match">赛事</Link> / 视频</div>
                <div className="video_play_container">
                    {this.props.match.params.id == 'a01786ijqla' &&
                        <p>2015全国击剑冠军赛总决赛青年组决赛</p>
                    }
                    {this.props.match.params.id == 'f0032t8ftgp' &&
                        <p>绍兴柯桥 首届击剑冠军赛火热开赛</p>
                    }
                    {this.props.match.params.id == 'b3006nt3239' &&
                        <p>第二届中国击剑大师赛在昌落幕</p>
                    }
                    {this.props.match.params.id == 't089999q0qi' &&
                        <p>武汉军运会击剑测试赛开赛</p>
                    }
                    {this.props.match.params.id == 'a0863uizi9r' &&
                        <p>全国击剑冠军赛 千余名剑客上虞“论剑”</p>
                    }
                    {this.props.match.params.id == 'a0930ar1pv3' &&
                        <p>2018-2019赛季全国击剑冠军赛（总决赛）23日比赛集锦</p>
                    }
                    {this.props.match.params.id == 't09287v6zmt' &&
                        <p>2018-2019赛季全国击剑总决赛（二）</p>
                    }
                    {this.props.match.params.id == 'j30065rrb9d' &&
                        <p>2019“国庆杯”武汉市击剑冠军赛</p>
                    }
                    {this.props.match.params.id == 'k09022di15l' &&
                        <p>2019世界击剑锦标赛女重团体决赛（中国VS俄罗斯）</p>
                    }
                    {this.props.match.params.id == 'f0929g3wzib' &&
                        <p>全国击剑冠军赛总决赛第三日集锦</p>
                    }
                    {this.props.match.params.id == 'hero03.mp4' &&
                        <p>广东击剑队队员邓小浩专访</p>
                    }
                    {this.props.match.params.id == 'p0818mq4x5k' &&
                        <p>击剑运动员 雷声 演讲</p>
                    }
                    {this.props.match.params.id == 'm0365vyb5vh' &&
                        <p>击剑运动员孙伟 访谈</p>
                    }
                    {this.props.match.params.id == 's300570td9z' &&
                        <p>击剑运动员许安琪 访谈</p>
                    }
                    {this.props.match.params.id == 'hero06.mp4' &&
                        <p>中国击剑访谈</p>
                    }
                    {this.props.match.params.id == 'j0914to7cbv' &&
                        <p>二青会击剑比赛 西安女子花剑勇夺团体冠军</p>
                    }
                    {this.props.match.params.id == 'x03054ms6rg' &&
                        <p>2016国际剑联上海花剑大奖赛</p>
                    }
                    {this.props.match.params.id == 'w07459h9de8' &&
                        <p>2018击剑世锦赛 女重个人 林声 vs KOR</p>
                    }
                    {this.props.match.params.id == 'r3017ax0ge4' &&
                        <p>2020赛季女重世界杯塔林 半决 孙一文vs波佩斯库</p>
                    }
                    {this.props.match.params.id == 'k30105ua5t5' &&
                        <p>孙一文军运会夺金</p>
                    }
                    {this.props.match.params.id == 'f0547oqk6x0' &&
                        <p>孙一文全运会女团冠军</p>
                    }
                    {this.props.match.params.id == 'q0867iwfnkh' &&
                        <p>2019哥伦比亚重剑大奖赛 - 女重个人决赛 - 孙一文</p>
                    }
                    {this.props.match.params.id == 'm0194k9kzyc' &&
                        <p>2016亚洲击剑锦标赛女子重剑个人决赛-孙玉洁VS许安琪</p>
                    }
                    {this.props.match.params.id == 'p0553qh9axv' &&
                        <p>第十三届全运会击剑女子重剑个人决赛 郝佳露VS许安琪</p>
                    }

                    {this.props.match.params.id == 'l0551biltf7' &&
                        <p>2018重剑世界杯巴塞罗那站决赛朱明叶夺冠</p>
                    }
                    {this.props.match.params.id == 'k0729xsmp8j' &&
                        <p>击剑世锦赛：男子佩剑中国选手全部晋级淘汰赛，许英明6战6胜</p>
                    }
                    {this.props.match.params.id == 'g08062ooryv' &&
                        <p>2018俱乐部击剑总决赛孙伟</p>
                    }
                    {this.props.match.params.id == 'f0384si8eyf' &&
                        <p>晋江击剑小将施嘉洛率福建男花夺冠</p>
                    }

                    
                    <div className="video_box">
                        {this.props.match.params.type == 2 &&
                            <video src={require('./../../video/'+this.props.match.params.id)} controls autoPlay></video>
                        }
                        {this.props.match.params.type == 1 &&
                            <iframe src={"http://v.qq.com/txp/iframe/player.html?vid="+this.props.match.params.id}></iframe>
                        }
                    </div>
                   
                </div>
                <div className="event_review other_match">
                    <p>其他精彩赛事</p>
                    <ul className="list">
                        {this.props.match.params.id != 't09287v6zmt' &&
                            <Link to={"/video/t09287v6zmt/1"}>
                            <li>
                                <img src={require('./../../pic/champion03.jpg')} alt=""></img><p>2018-2019赛季全国击剑总决赛（二）</p>
                                <div className="play">
                                    <img src={playOS} alt=""></img>
                                    <span>播放量：105</span>
                                </div>
                            </li>
                            </Link>
                        }
                        {this.props.match.params.id != 'a0930ar1pv3' &&
                            <Link to={"/video/a0930ar1pv3/1"}>
                            <li>
                                <img src={require('./../../pic/champion02.jpg')} alt=""></img><p>2018-2019赛季全国击剑冠军赛</p>
                                <div className="play">
                                    <img src={playOS} alt=""></img>
                                    <span>播放量：210</span>
                                </div>
                            </li>
                            </Link>
                        }
                        {this.props.match.params.id != 'j30065rrb9d' &&
                            <Link to={"/video/j30065rrb9d/1"}>
                            <li>
                                <img src={require('./../../pic/champion04.jpg')} alt=""></img><p>2019“国庆杯”武汉市击剑冠军赛'</p>
                                <div className="play">
                                    <img src={playOS} alt=""></img>
                                    <span>播放量：106</span>
                                </div>
                            </li>
                            </Link>
                        }
                        {this.props.match.params.id != 'j0914to7cbv' &&
                            <Link to={"/video/j0914to7cbv/1"}>
                            <li>
                                <img src={require('./../../pic/champion06.jpg')} alt=""></img><p>二青会击剑比赛 西安女子花剑勇夺团体冠军</p>
                                <div className="play">
                                    <img src={playOS} alt=""></img>
                                    <span>播放量：403</span>
                                </div>
                            </li>
                            </Link>
                        }
                        {this.props.match.params.id != 'a01786ijqla' &&
                            <Link to={"/video/a01786ijqla/1"}>
                            <li>
                                <img src={require('./../../pic/champion01.jpg')} alt=""></img><p>2015全国击剑冠军赛总决赛青年组决赛</p>
                                <div className="play">
                                    <img src={playOS} alt=""></img>
                                    <span>播放量：251</span>
                                </div>
                            </li>
                            </Link>
                        }
                        {this.props.match.params.id != 'k09022di15l' &&
                            <Link to={"/video/k09022di15l/1"}>
                            <li>
                                <img src={require('./../../pic/champion05.jpg')} alt=""></img><p>2019世界击剑锦标赛女重团体决赛（中国VS俄罗斯）</p>
                                <div className="play">
                                    <img src={playOS} alt=""></img>
                                    <span>播放量：305</span>
                                </div>
                            </li>
                            </Link>
                        }
                        {this.props.match.params.id == 'f0929g3wzib' &&
                        <Link to={"/video/f0929g3wzib/1"}>
                            <li>
                                <img src={require('./../../pic/champion07.jpg')} alt=""></img><p>全国击剑冠军赛总决赛第三日集锦</p>
                                <div className="play">
                                    <img src={playOS} alt=""></img>
                                    <span>播放量：325</span>
                                </div>
                            </li>
                        </Link>
                        }
                    </ul>
                </div>
            </main>
        )
    }
};